// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__arFij","bigColWidth":"Table_bigColWidth__3hSR4","biggerColWidth":"Table_biggerColWidth__3aGtS","row":"Table_row__2ijv8","col":"Table_col__2jH0n"};